module.exports = __webpack_public_path__ + "static/jdc-2663b7015ed268ba750e00091770142c.png";